import { selectBrokerConsultantBannerUrl } from './selectBrokerConsultantBannerUrl';
import { IApplicationState } from '../../types/redux';

export function selectBrokerConsultantBannerAvailable(state: IApplicationState) {
  return Boolean(selectBrokerConsultantBannerUrl(state));
}
